export const NEXT_TRACK_PREPARE_SECONDS = 45;

export function selectNextTrackIndex(currentIndex, trackCount, shuffleEnabled, randomValue = Math.random()) {
  if (!trackCount) return -1;
  if (!shuffleEnabled || trackCount === 1) return (currentIndex + 1) % trackCount;
  const offset = 1 + Math.floor(randomValue * (trackCount - 1));
  return (currentIndex + offset) % trackCount;
}

export function shouldPrepareNextTrack(currentTime, duration, previewMode) {
  return !previewMode
    && Number.isFinite(currentTime)
    && Number.isFinite(duration)
    && duration > 0
    && duration - currentTime <= NEXT_TRACK_PREPARE_SECONDS;
}
